<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e2JJKQ/tc-custom/9781504075206.jpg?1705766094826" alt="This image is the cover for the book Sleepers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sleepers
      </h1>
      <p class="bookDescription body article font2">
        <p>“Once you start you just have to know what's going to happen next . . . totally thrilling!” —Goodreads reviewer, five stars<br/><br/><b>A time bomb is ticking—but what if that time bomb is you? A chilling novel of intrigue, terror, and one man and woman in a race against the clock . . .</b><br/><br/> Sylvie is running. Running from the memories of a terror attack in London she experienced as a child, a catastrophic event in which her brother died. Running from her abusive boyfriend. And running from a warning, given to her on a station platform in Nantes: Someone is trying to kill her.<br/><br/> Corran isn’t really Corran. He’s working deep undercover to infiltrate the political organisation that looks set to win the upcoming British election—a group that doesn’t appear to have existed a few years ago. Corran has been sent to find out who’s behind them and what their true agenda might be.<br/><br/> But he messes up. All he has is a list of names, Sylvie’s included. Only with time does he begin to see the connections. Are those on the list, who were caught up in the London terror attack ten years ago, now being systematically taken out? The hit list will force Corran and Sylvie into a reluctant partnership, and into the centre of a looming threat that could explode at any moment . . .<br/><br/> “Sucks you in from page one and doesn’t let go. Packed with tremendous action.” —Rob Samborn, author of <i>The Prisoner of Paradise</i> and <i>Painter of the Damned</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        KM Kelly
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?be4faa3a